import {
	TOGGLE_MAIN_DRAWER,
	CLOSE_MAIN_DRAWER,
	TOGGLE_CART_DRAWER,
	CLOSE_CART_DRAWER,
	SHOW_CHIP,
	DELETE_CHIP,
} from './constants';

// action to toggle the state of the app drawer
const toggleMainDrawer = () => ({
	type: TOGGLE_MAIN_DRAWER,
});

// action to explicitly close the app drawer
const closeMainDrawer = () => ({
	type: CLOSE_MAIN_DRAWER,
});

const toggleCartDrawer = () => ({
	type: TOGGLE_CART_DRAWER,
});

// action to explicitly close the app drawer
const closeCartDrawer = () => ({
	type: CLOSE_CART_DRAWER,
});

const showChip = text => ({
	type: SHOW_CHIP,
	chipText: text,
});

const deleteChip = () => ({
	type: DELETE_CHIP,
});

export {
	toggleMainDrawer,
	closeMainDrawer,
	toggleCartDrawer,
	closeCartDrawer,
	showChip,
	deleteChip,
};
